const locales = [
  {
    code: "lo",
    name: "ພາສາລາວ",
    translations: [
      {
        key: "dashboard1Title",
        value: "ແມ່ ແລະ ເດັກ: ການເສຍຊີວິດ",
      },
      {
        key: "dashboard2Title",
        value: "ເກີດລູກມີແພດຊ່ວຍ",
      },
      {
        key: "dashboard3Title",
        value: "Penta 3",
      },
      {
        key: "widget1.1Title",
        value: `ເດັກນ້ອຍອາຍຸຕ່ຳກວ່າ1ປີ ເສຍຊີວິດ (ກໍລະນີ) - {{year}}`,
      },
      {
        key: "widget1.2Title",
        value: `ເດັກນ້ອຍອາຍຸຕ່ຳກວ່າ5ປີ ເສຍຊີວິດ (ກໍລະນີ) - {{year}}`,
      },
      {
        key: "widget1.3Title",
        value: `ແມ່ ເສຍຊີວິດ (ກໍລະນີ) - {{year}}`,
      },
      {
        key: "widget1.4Title",
        value: `ອັດຕາການເສຍຊີວິດ ເດັກນ້ອຍອາຍຸຕ່ຳກວ່າ1ປີ (ຕໍ່ 10,000) - {{year}}`,
      },
      {
        key: "widget1.5Title",
        value: `ອັດຕາການເສຍຊີວິດ ເດັກນ້ອຍອາຍຸຕ່ຳກວ່າ5ປີ (ຕໍ່ 10,000) - {{year}}`,
      },
      {
        key: "widget1.6Title",
        value: `ອັດຕາການເສຍຊີວິດ ແມ່ (ຕໍ່ 100,000) - {{year}}`,
      },
      // {
      //   key: "widget1.4Title",
      //   value: "ຈຳນວນແມ່ແລະເດັກຕາຍໃນ 36​ເດືອນຜ່ານມາ",
      // },
      // {
      //   key: "widget1.5Title",
      //   value: "ຈຳນວນແມ່ຕາຍ",
      // },
      // {
      //   key: "widget1.6Title",
      //   value: "ຈຳນວນແມ່ແລະເດັກຕາຍໃນ 36​ເດືອນຜ່ານມາ",
      // },
      {
        key: "widget1.9Title",
        value: "ຈຳນວນເດັກຕາຍໃນ 5 ​ປີຜ່ານມາ",
      },
      // {
      //   key: "widget1.9Title",
      //   value: "PHEOC: ອັດຕາການລາຍງານຂໍ້ມູນພະຍາດເຝົ້າລະວັງຂອງແຕ່ລະແຂວງ",
      // },
      {
        key: "widget1.13Title",
        value: "NCLE Data Quality FEB 2023",
      },
      { key: "monthlyHeaderTitleOfWidget1.9", value: `{{month}} {{year}}` },
      { key: "weeklyHeaderTitleOfWidget1.9", value: `ອາທິດ{{month}} {{year}}` },
      { key: "widget1.1Date", value: `As on {{date}}` },
      { key: "lastPeriod", value: `ໄລຍະເວລາດຽວກັນ ຂອງປີທີ່ແລ້ວ: {{value}}` },
      { key: "headerTitleWidget1.7", value: "ຂໍ້ມູນ/ຊ່ວງເວລາ" },
      { key: "headerTitleWidget1.9", value: "ຫົວໜ່ວຍການຈັດຕັ້ງ/ຊ່ວງເວລາ" },
      { key: "jan", value: "ເດືອນມັງກອນ" },
      { key: "feb", value: "ເດືອນກຸມພາ" },
      { key: "mar", value: "ເດືອນມີນາ" },
      { key: "apr", value: "ເດືອນເມສາ" },
      { key: "may", value: "ເດືອນພຶດສະພາ" },
      { key: "jun", value: "ເດືອນມິຖຸນາ" },
      { key: "jul", value: "ເດືອນກໍລະກົດ" },
      { key: "aug", value: "ເດືອນສິງຫາ" },
      { key: "sep", value: "ເດືອນກັນຍາ" },
      { key: "oct", value: "ເດືອນຕຸລາ" },
      { key: "nov", value: "ເດືອນພະຈິກ" },
      { key: "dec", value: "ເດືອນທັນວາ" },
      {
        key: "widget1.12Title",
        value:
          "ແມ່ແລະເດັກ: ອັດຕາການລາຍງານຂໍ້ມູນແລະລາຍງານຕົງເວລາ ເບິ່ງເປັນແຂວງ - {{year}}",
      },
      {
        key: "widget1.11.1Title",
        value:
          "ເດັກນ້ອຍອາຍຸຕ່ຳກວ່າ1ປີ ເສຍຊີວິດ (ກໍລະນີ) ເບິ່ງເປັນແຂວງ - {{year}}",
      },
      {
        key: "widget1.11.2Title",
        value:
          "ເດັກນ້ອຍອາຍຸຕ່ຳກວ່າ5ປີ ເສຍຊີວິດ (ກໍລະນີ) ເບິ່ງເປັນແຂວງ - {{year}}",
      },
      {
        key: "widget1.11.3Title",
        value: "ແມ່ ເສຍຊີວິດ (ກໍລະນີ) ເບິ່ງເປັນແຂວງ - {{year}}",
      },
      {
        key: "widget1.10.1Title",
        value:
          "ອັດຕາການເສຍຊີວິດ ເດັກນ້ອຍອາຍຸຕ່ຳກວ່າ1ປີ (ສະເລ່ຍເປັນປີ) ເບິ່ງເປັນແຂວງ - {{year}}",
      },
      {
        key: "widget1.10.2Title",
        value:
          "ອັດຕາການເສຍຊີວິດ ເດັກນ້ອຍອາຍຸຕ່ຳກວ່າ5ປີ (ສະເລ່ຍເປັນປີ) ເບິ່ງເປັນແຂວງ - {{year}}",
      },
      {
        key: "widget1.10.3Title",
        value: "ອັດຕາການເສຍຊີວິດ ແມ່ (ສະເລ່ຍເປັນປີ) ເບິ່ງເປັນແຂວງ - {{year}}",
      },
      {
        key: "widget1.7.1Title",
        value: "ເດັກນ້ອຍອາຍຸຕ່ຳກວ່າ1ປີ ເສຍຊີວິດ (ກໍລະນີ) - 3 ປີຜ່ານມາ",
      },
      {
        key: "widget1.7.2Title",
        value: "ເດັກນ້ອຍອາຍຸຕ່ຳກວ່າ5ປີ ເສຍຊີວິດ (ກໍລະນີ) - 3 ປີຜ່ານມາ",
      },
      {
        key: "widget1.7.3Title",
        value: "ແມ່ ເສຍຊີວິດ (ກໍລະນີ) - 3 ປີຜ່ານມາ",
      },
      {
        key: "widget1.8.1Title",
        value:
          "ອັດຕາການເສຍຊີວິດ ເດັກນ້ອຍອາຍຸຕ່ຳກວ່າ1ປີ (ສະເລ່ຍເປັນປີ) - 3 ປີຜ່ານມາ",
      },
      {
        key: "widget1.8.2Title",
        value:
          "ອັດຕາການເສຍຊີວິດ ເດັກນ້ອຍອາຍຸຕ່ຳກວ່າ5ປີ (ສະເລ່ຍເປັນປີ) - 3 ປີຜ່ານມາ",
      },
      {
        key: "widget1.8.3Title",
        value: "ອັດຕາການເສຍຊີວິດ ແມ່ (ສະເລ່ຍເປັນປີ) - 3 ປີຜ່ານມາ",
      },
      {
        key: "widget2.1Title",
        value: "ເກີດລູກມີແພດຊ່ວຍ (ກໍລະນີ) - {{year}}",
      },
      {
        key: "widget2.2Title",
        value: "ຄາດຄະເນການເກີດມີຊີວິດ (ກໍລະນີ) - {{year}}",
      },
      {
        key: "widget2.3Title",
        value:
          "ອັດຕາການຄອບຄຸມ ຂອງການເກີດລູກມີແພດຊ່ວຍ (ສະເລ່ຍເປັນປີ) - {{year}}",
      },
      {
        key: "widget2.4.1Title",
        value: "ການເກີດລູກມີແພດຊ່ວຍ (ກໍລະນີ) - 3 ປີຜ່ານມາ",
      },
      {
        key: "widget2.4.2Title",
        value:
          "ອັດຕາການຄອບຄຸມ ຂອງການເກີດລູກມີແພດຊ່ວຍ (ສະເລ່ຍເປັນປີ) - 3 ປີຜ່ານມາ",
      },
      {
        key: "widget2.5.1Title",
        value: "ການເກີດລູກມີແພດຊ່ວຍ ເບິ່ງເປັນແຂວງ(ກໍລະນີ) - {{year}}",
      },
      {
        key: "widget2.5.2Title",
        value:
          "ອັດຕາການຄອບຄຸມ ຂອງການເກີດລູກມີແພດຊ່ວຍ (ສະເລ່ຍເປັນປີ) ເບິ່ງເປັນແຂວງ - {{year}}",
      },
      {
        key: "widget2.6Title",
        value: "ການເກີດລູກມີແພດຊ່ວຍ ເບິ່ງເປັນແຂວງ(ກໍລະນີ) - {{year}}",
      },
      {
        key: "widget2.7Title",
        value:
          "ອັດຕາການຄອບຄຸມ ຂອງການເກີດລູກມີແພດຊ່ວຍ (ສະເລ່ຍເປັນປີ) ເບິ່ງເປັນແຂວງ - {{year}}",
      },
      {
        key: "widget2.8Title",
        value:
          "ການເກີດລູກມີແພດຊ່ວຍ: ອັດຕາການລາຍງານຂໍ້ມູນແລະລາຍງານຕົງເວລາ ເບິ່ງເປັນແຂວງ - {{year}}",
      },
      { key: "widget2.9Title", value: "Repoting rate heat map" },
      {
        key: "widget4.1Title",
        value: "% ສະມາຊິກຄອບຄົວທີ່ໄດ້ຮັບການລົງທະບຽນ",
      },
      {
        key: "widget4.2Title",
        value: "% ຂອງຄອບຄົວທີ່ບໍ່ມີເລກສຳມະໂນຄົວ",
      },
      { key: "widget4.3Title", value: "ຈຳນວນຂອງຄອບຄົວທີ່ໄດ້ຮັບການລົງທະບຽນ" },
      {
        key: "widget4.4Title",
        value: "ຈຳນວນຂອງສະມາຊິກຄອບຄົວທີ່ໄດ້ຮັບການລົງທະບຽນ",
      },
      {
        key: "widget4.5Title",
        value:
          "% ປຽບທຽບ ສະມາຊິກຄອບຄົວທີ່ໄດ້ຮັບການລົງທະບຽນ ກັບ ຕົວເລກຂອງສູນສະຖິຕິ",
      },
      { key: "widget4.6Title", value: "ປະເພດແຫຼ່ງນ້ຳຂອງຄອບຄົວ" },
      { key: "widget4.7Title", value: "ປະເພດວິດຖ່າຍຂອງຄອບຄົວ" },
      {
        key: "widget4.8Title",
        value: "ລະດັບການສຶກສາຂອງສະມາຊິກຄອບຄົວ",
      },
      {
        key: "widget4.9Title",
        value: "ປະເພດຊົນເຜົ່າຂອງສະມາຊິກຄອບຄົວ",
      },
      { key: "widget4.10Title", value: "ປະເພດຄວາມພິການຂອງຄອບຄົວ" },
      {
        key: "dashboard4Title",
        value: "ລະບົບຂໍ້ມູນຂ່າວສານແຟ້ມຄອບຄົວ",
      },
      { key: "lastMonth", value: `Last month: {{value}}` },
      {
        key: "dashboard3_widget1.1Title",
        value: `Penta3 Immunization total this month {{year}}`,
      },
      {
        key: "dashboard3_widget2.1Title",
        value: `Penta3 Immunization coverage this month {{year}}`,
      },
      {
        key: "dashboard3_widget3.1Title",
        value: `Penta3 Immunization total {{year}}`,
      },
      {
        key: "dashboard3_widget4.1Title",
        value: `Penta3 Immunization coverage {{year}}`,
      },
      {
        key: "dashboard3_widget5.1Title",
        value: `Monthly Penta3`,
      },
      {
        key: "dashboard3_widget6.1Title",
        value: `Monthly Penta 3 By Province`,
      },
      {
        key: "dashboard3_Widget9.1Title",
        value: `Epi Penta3 Coverage {{year}}`,
      },
      {
        key: "dashboard3_Widget10.1Title",
        value: `Monthly Penta 3 {{year}}`,
      },
      {
        key: "dashboard3_Widget11.1Title",
        value: `EPI DB Reporting and Timeliness Rate Lao PDR {{year}}`,
      },
      {
        key: "dashboard3_Widget12.1Title",
        value: `EPI DB Reporting Rate Heat Map Lao PDR {{year}}`,
      },
      {
        key: "target",
        value: "Target",
      },
      {
        key: "lastUpdated",
        value: "ມື້ທີ່ດຶງຂໍ້ມູນ",
      },
      { key: "asAt", value: "ຂໍ້ມູນຮອດວັນທີ" },
      {
        key: "dashboard5_widget1.1Title",
        value: "ພະຍາດ/ອາການປ້ອງກັນດ້ວຍຢາວັກຊິນ (ກໍລະນີ) - {{year}}",
      },
      {
        key: "dashboard5_widget2.1Title",
        value: "ໄຂ້​ຍຸງ​ລາຍ (ກໍລະນີ) - {{year}}",
      },
      {
        key: "dashboard5_widget3.1Title",
        value: "ພະຍາດທີ່ເກີດຈາກອາຫານ ແລະ ນໍ້າ (ກໍລະນີ) - {{year}}",
      },
      {
        key: "dashboard5_widget4.1Title",
        value: "ອາການຊຶມເຊື້ອລະບົບຫາຍໃຈຮຸນແຮງກະທັນຫັນ (ກໍລະນີ) - {{year}}",
      },
      {
        key: "dashboard5_widget5.1Title",
        value: "ອາການຈາກສັດສູ່ຄົນ ແລະ ອຶ່ນໆ (ກໍລະນີ) - {{year}}",
      },
      {
        key: "dashboard5_widget6.1Title",
        value: "ພະຍາດ/ອາການປ້ອງກັນດ້ວຍຢາວັກຊິນ (ກໍລະນີ) - {{year}}",
      },
      {
        key: "dashboard5_widget7.1Title",
        value:
          "ພະຍາດ/ອາການປ້ອງກັນດ້ວຍຢາວັກຊິນ ເບິ່ງເປັນແຂວງ (ກໍລະນີ) - {{year}}",
      },
      {
        key: "dashboard5_widget8.1Title",
        value: "ໄຂ້​ຍຸງ​ລາຍ (ກໍລະນີ) - {{year}}",
      },
      {
        key: "dashboard5_widget9.1Title",
        value: "ໄຂ້​ຍຸງ​ລາຍ ເບິ່ງເປັນແຂວງ (ກໍລະນີ) - {{year}}",
      },
      {
        key: "dashboard5_widget10.1Title",
        value: "ພະຍາດທີ່ເກີດຈາກອາຫານ ແລະ ນໍ້າ (ກໍລະນີ) - {{year}}",
      },
      {
        key: "dashboard5_widget11.1Title",
        value:
          "ພະຍາດທີ່ເກີດຈາກອາຫານ ແລະ ນໍ້າ ເບິ່ງເປັນແຂວງ (ກໍລະນີ) - {{year}}",
      },
      {
        key: "dashboard5_widget12.1Title",
        value: "ອາການຊຶມເຊື້ອລະບົບຫາຍໃຈຮຸນແຮງກະທັນຫັນ (ກໍລະນີ) - 3 ປີຜ່ານມາ",
      },
      {
        key: "dashboard5_widget13.1Title",
        value:
          "ອາການຊຶມເຊື້ອລະບົບຫາຍໃຈຮຸນແຮງກະທັນຫັນ ເບິ່ງເປັນແຂວງ (ກໍລະນີ) - {{year}}",
      },
      {
        key: "dashboard5_widget14.1Title",
        value: "ອາການຈາກສັດສູ່ຄົນ ແລະ ອຶ່ນໆ (ກໍລະນີ) - {{year}}",
      },
      {
        key: "dashboard5_widget15.1Title",
        value: "ອາການຈາກສັດສູ່ຄົນ ແລະ ອຶ່ນໆ (ກໍລະນີ) - {{year}}",
      },
      {
        key: "dashboard5_widget16.1Title",
        value: "ອັດຕາການລາຍງານຂໍ້ມູນພະຍາດເຝົ້າລະວັງຂອງແຕ່ລະແຂວງ - {{year}}",
      },
      {
        key: "dashboard5_widget17.1Title",
        value:
          "ອັດຕາການລາຍງານຂໍ້ມູນພະຍາດເຝົ້າລະວັງຂອງແຕ່ລະແຂວງ (ສະເລ່ຍເປັນປີ) - {{year}}",
      },
      {
        key: "dashboard5Title",
        value: "ສວລ - ເຝົ້າລະວັງ 18 ອາການພະຍາດ",
      },
      {
        key: "dashboard6_widget1Title",
        value: "ເສັ້ນສະແດງ ວົງຈອນຊີວິດ - 12 ເດືອນທີ່ຜ່ານມາ",
      },
      {
        key: "dashboard6_widget2Title",
        value:
          "ອັດຕາການຕົກຫຼົ່ນ ຂອງຈຳນວນແມ່ຍິງທີ່ມາກວດທ້ອງກ່ອນເກີດຄັ້ງທີ1 ແລະ ຄັ້ງທີ4 - 12 ເດືອນທີ່ຜ່ານມາ",
      },
      {
        key: "dashboard6_widget3Title",
        value:
          "ອັດຕາການຕົກຫຼົ່ນ ຂອງຈຳນວນທີ່ສັກຢາ Penta1 ແລະ Penta3 - 12 ເດືອນທີ່ຜ່ານມາ",
      },
      {
        key: "dashboard6_widget4Title",
        value:
          "ຂໍ້ມູນສັກຢາ: ອັດຕາການລາຍງານຂໍ້ມູນແລະລາຍງານຕົງເວລາ ເບິ່ງເປັນແຂວງ - 12 ເດືອນທີ່ຜ່ານມາ",
      },
      {
        key: "dashboard6Title",
        value: "ແມ່ ແລະ ເດັກ",
      },
      {
        key: "REPORTING_RATE",
        value: "ອັັດຕາການລາຍງານ",
      },
      {
        key: "REPORTING_RATE_ON_TIME",
        value: "ອັັດຕາການລາຍງານ ຕົງເວລາ",
      },
      {
        key: "dataFromDhis2",
        value: "ຂໍ້ມູນທີ່ລາຍງານໃນລະບົບ DHIS 2 ເທົ່ານັ້ນ",
      },
      {
        key: "widget2.5.1LegendTitle",
        value: "ຈຳນວນເກີດລູກມີແພດຊ່ວຍ ທັງໝົດ",
      },
      {
        key: "widget2.5.2LegendTitle",
        value: "MCH: ອັດຕາການຄອບຄຸມ ຂອງການເກີດລູກມີແພດຊ່ວຍ (ສະເລ່ຍເປັນປີ)",
      },
      {
        key: "dashboard7Title",
        value: "ຄູ່ມືລະບົບ HMIS ຂອງ ສປປລາວ",
      },
      {
        key: "dashboard8Title",
        value: "ສະຖານທີ່ບໍລິການສາທາລະນະສຸກ",
      },
      {
        key: "dashboard9Title",
        value: "ກະດານຂ່າວໂພຊະນາການ",
      },
      {
        key: "dashboard8_widget1Title",
        value: "ລາຍຊື່ສະຖານທີ່ບໍລິການສາທາລະນະສຸກ",
      },
      {
        key: "Quarterly Nutrition Scorecard - Key Indicators",
        value: "Quarterly Nutrition Scorecard - Key Indicators LAOs",
      },
      {
        key: "Quarterly Nutrition Scorecard - Data Quality",
        value: "ຕາຕະລາງຄະແນນໂພຊະນາການປະຈໍາໄຕມາດ-ຄນຸ ນະພາບຂມ  ູນ",
      },
      { key: "accessToFacility", value: "Access To Facility" },
      { key: "facilityInformation", value: "Facility Information" },
      { key: "facilityInfrastructure", value: "Facility Infrastructure" },
      { key: "serviceDetailsLastYear", value: "Service Details Last Year" },
      { key: "servicesProvided", value: "Services Provided" },
      { key: "staffDetails", value: "Staff Details" },
      { key: "all", value: "All" },
      { key: "provided", value: "Provided" },
      { key: "notProvided", value: "Not provided" },
      { key: "dashboard8_tabWidgetTitle", value: "Select section" },
      { key: "summary", value: "ລວມ" },
      { key: "departmentsOrOffices", value: "ພະແນກ/ຫ້ອງການ" },
      { key: "hospitalsByProvince", value: "ໂຮງໝໍແຕ່ລະແຂວງ" },
      { key: "hospitalsByLevel", value: "ໂຮງໝໍແຕ່ລະຂັ້ນ" },
      { key: "allHospitals", value: "ໂຮງໝໍທັງໝົດ" },
      { key: "province", value: "ແຂວງ " },
      { key: "district", value: "ເມືອງ" },
      { key: "healthCenter", value: "ໂຮງໝໍນ້ອຍ" },
      { key: "capitalOrProvince", value: "ນະຄອນຫຼວງ / ແຂວງ" },
      { key: "hospitalTotal", value: "ໂຮງຫມໍທັງໝົດ" },
      { key: "capitalOrProvinceHospital", value: "ພສນ/ຂ" },
      { key: "provinceHospital", value: "ຮໝຂ" },
      { key: "districtHospital", value: "ຫສມ" },
      { key: "districtHospitalCommunity", value: "ຮໝຊ" },
      { key: "districtHospitalCommunityTotal", value: "DH ລວມ" },
      { key: "districtHospitalCommunityA", value: "ຮໝຊ(ກ)" },
      { key: "districtHospitalCommunityB", value: "ຮໝຊ(ຂ)" },
      { key: "healthCenterWithCode", value: "ຮໝນ" },
      { key: "code", value: "Code" },
      { key: "total", value: "ລວມ" },
      { key: "centralHospital", value: "ໂຮງໝໍສູນກາງ (ຮໝສ)" },
      { key: "tag", value: "Tag" },
      { key: "hfid", value: "HFID" },
      { key: "type", value: "ປະເພດ" },
      { key: "shortName", value: "ຊື່ສັ້ນ" },
      { key: "name", value: "ຊື່ຍາວ" },
      { key: "yes", value: "Yes" },
      { key: "no", value: "No" },
      { key: "homeTitle", value: "ກະດານຂ່າວສາທາລະນະສຸກ ສຳລັບຜູ້ບໍລິຫານ" },
      {
        key: "homeSubTitle",
        value:
          "ກະດານຂ່າວສາທາລະນະສຸກ ສຳລັບຜູ້ບໍລິຫານ ແມ່ນເຄື່ອງມືທີ່ນຳສະເໜີພາບລວມເພື່ອສ້າງຄວາມເຂົ້າໃຈກ່ຽວກັບສະພາບການດ້ານສາທາລະນະສຸກຂອງ ສປປລາວ.",
      },
      {
        key: "homeDashboardTitle",
        value: "ໜ້າຫຼັກ",
      },
      { key: "pleaseSelectDashboard", value: "ເລືອກກະດານຂ່າວ" },
      {
        key: "disclaimer",
        value: "*ໝາຍເຫດ*",
      },
      {
        key: "disclaimerSubTitle",
        value:
          "ຂໍ້ມູນທີ່ສະແດງໃນກະດານຂ່າວນີ້ແມ່ນສຳລັບເປັນຂໍ້ມູນໃນການຕິດຕາມເທົ່ານັ້ນ, ບໍ່ສາມາດໃຊ້ເປັນຂໍ້ມູນອ້າງອີງໃນເອກະສານແລະເປັນທາງການໄດ້.",
      },
      {
        key: "aboutSectionTitle",
        value: "ກ່ຽວກັບ ກະດານຂ່າວສາທາລະນະສຸກ ສຳລັບຜູ້ບໍລິຫານ",
      },
      {
        key: "aboutSectionLine1",
        value:
          "ກະດານຂ່າວສາທາລະນະສຸກ ສຳລັບຜູ້ບໍລິຫານ ແມ່ນເວັບໄຊ້ທີ່ນຳສະເໜີຂໍ້ມູນດ້ານສາທາລະນະສຸກ ທີ່ພັດທະນາຂຶ້ນໂດຍກົມແຜນການແລະການເງິນ, ກະຊວງສາທາລະນະສຸກ.",
      },
      {
        key: "aboutSectionLine2",
        value:
          "ກະດານຂ່າວນີ້ແມ່ນເຄື່ອງມືທີ່ເປັນປະໂຫຍດສຳລັບພະນັກງານສາທາລະນະສຸກ ໃນການເຂົ້າເຖິງຂໍ້ມູນກ່ຽວກັບສະຖານະການ ແລະ ແນວໂນ້ມດ້ານສາທາລະນະສຸກດ້ານສາທາລະນະສຸກຕ່າງໆ ເພື່ອໃຊ້ໃນການທຳຄວາມເຂົ້າໃຈ ແລະ ຊ່ວຍໃນການພັດທະນາ ປັດໄຈດ້ານສາທາລະນະສຸກເພື່ອປະຊາຊົນລາວ.",
      },
      {
        key: "howToUseTitle",
        value: "ວິທີໃຊ້ ກະດານຂ່າວສາທາລະນະສຸກ ສຳລັບຜູ້ບໍລິຫານ",
      },
      {
        key: "howToUseLine1",
        value:
          "ຈາກໜ້າຫຼັກ ທ່ານສາມາດເລືອກເອົາກະດານຂ່າວຕ່າງໆຈາກໂຕເລືອກທາງກາງ ຫຼື ຢູ່ດ້ານຊ້າຍເທິງຂອງໜ້າເວັບໄຊ້.",
      },
      {
        key: "howToUseLine2",
        value:
          "ກະດານຂ່າວນີ້ສາມາດສະແດງຂໍ້ມູນໄດ້ໃນຮູບແບບຕ່າງໆທີ່ຜູ້ໃຊ້ງານສາມາດເລືອກປ່ຽນໄປມາໄດ້ ໂດຍກົດທີ່ປຸ່ມ “...” ຄືຮູບທາງລຸ່ມ:",
      },
      {
        key: "whoIsDashboardForTitle",
        value: "ກະດານຂ່າວສາທາລະນະສຸກ ສຳລັບຜູ້ບໍລິຫານ ແມ່ນສຳລັບໃຜ?",
      },
      {
        key: "whoIsDashboardForLine1",
        value:
          "ກະດານຂ່າວສາທາລະນະສຸກ ສຳລັບຜູ້ບໍລິຫານ ແມ່ນສຳລັບທຸກຄົນທີ່ມີຄວາມສົນໃຈຮັບຮູ້ຂໍ້ມູນດ້ານສາທາລະນະສຸກຕ່າງໆ ບໍ່ວ່າຈະເປັນ ການນຳ, ນັກວິໄຈ ຫຼື ພະນັກງານສາທາລະນະສຸກ ເພື່ອ:",
      },
      {
        key: "whoIsDashboardForLine2",
        value: "ຕິດຕາມສະຖານະການດ້ານສາທາລະນະສຸກ",
      },
      {
        key: "whoIsDashboardForLine3",
        value: "ສຶກສາແນວໂນ້ມຂອງຂໍ້ມູນດ້ານສາທາລະນະສຸກ",
      },
      {
        key: "whoIsDashboardForLine4",
        value:
          "ລວບລວມຂໍ້ມູນສຳລັບການພັດທະນະຍຸດທະສາດເພື່ອສ້າງຄວາມເຂັ້ມແຂງດ້ານສຸຂະພາບ ແລະ ສາທາລະນະສຸກຂອງ ສປປລາວ",
      },
      {
        key: "howDashboardMadeTitle",
        value: "ກະດານຂ່າວສາທາລະນະສຸກ ສຳລັບຜູ້ບໍລິຫານ ພັດທະນາໂດຍ:",
      },
      {
        key: "howDashboardMadeLine1",
        value:
          "ກົມແຜນການແລະການເງິນ, ກະຊວງສາທາລະນະສຸກ ຮ່ວມກັບ ອົງການ HISP ຫວຽດນາມ.",
      },
      { key: "control", value: "Control" },
      { key: "columns", value: "Columns" },
      { key: "filter", value: "Filter" },
      { key: "sort", value: "Sort" },
      { key: "filterBy", value: "Filter by {{label}}" },
      { key: "reset", value: "Reset" },
      { key: "emptyData", value: "Data is empty" },
      { key: "sortStatus", value: "Sort status" },
      { key: "asc", value: "Ascending (ASC)" },
      { key: "desc", value: "Descending (DESC)" },
      { key: "location", value: "Location" },
      { key: "facilityName", value: "Facility Name" },
      { key: "downloadExcel", value: "Download excel" },
      { key: "availableColumns", value: "Available columns" },
      { key: "selectedColumns", value: "Selected columns" },
      { key: "dashboard8_widget1_title", value: "Master Facilities List" },
      { key: "config", value: "Config" },

      {
        key: "profile",
        value: "Profile",
      },
      {
        key: "dataElement",
        value: "Data element",
      },
      {
        key: "dataValue",
        value: "Data value",
      },
      {
        key: "close",
        value: "Close",
      },
      {
        key: "trackedEntityAttribute",
        value: "Tracked entity instance",
      },
      {
        key: "detail",
        value: "Detail",
      },
      {
        key: "photoNotAvailable",
        value: "Photo not available",
      },
    ],
  },
  {
    code: "en",
    name: "English",
    translations: [
      {
        key: "dashboard1Title",
        value: "Mortality",
      },
      {
        key: "dashboard2Title",
        value: "Skilled birth attendance (SBA)",
      },
      {
        key: "dashboard3Title",
        value: "Penta 3",
      },
      {
        key: "widget1.1Title",
        value: `Infant Death - {{year}}`,
      },
      {
        key: "widget1.2Title",
        value: `Child Death - {{year}}`,
      },
      {
        key: "widget1.3Title",
        value: `Maternal Death - {{year}}`,
      },
      {
        key: "widget1.4Title",
        value: `Infant mortality (per 10,000) - {{year}}`,
      },
      {
        key: "widget1.5Title",
        value: `Child mortality (per 10,000) - {{year}}`,
      },
      {
        key: "widget1.6Title",
        value: `Maternal mortality (per 100,000) - {{year}}`,
      },
      // {
      //   key: "widget1.4Title",
      //   value: "Maternal and child mortality in the last 36 months - Lao PDR",
      // },
      // {
      //   key: "widget1.5Title",
      //   value: "Maternal deaths by provinces last year",
      // },
      // {
      //   key: "widget1.6Title",
      //   value: "Maternal and child mortality in the last 36 months - Lao PDR",
      // },
      {
        key: "widget1.9Title",
        value: "Reported children under five deaths last 5 year - Lao PDR",
      },
      // {
      //   key: "widget1.9Title",
      //   value:
      //     "PHEOC Surveillance - 00. Reporting rate by province, last 4 weeks and last month",
      // },
      {
        key: "widget1.13Title",
        value: "NCLE Data Quality FEB 2023",
      },
      {
        key: "dashboard9Title",
        value: "Nutrition Dashboard",
      },
      { key: "monthlyHeaderTitleOfWidget1.9", value: `{{month}} {{year}}` },
      { key: "weeklyHeaderTitleOfWidget1.9", value: `W{{month}} {{year}}` },
      { key: "widget1.1Date", value: `As on {{date}}` },
      { key: "lastPeriod", value: `Same period last year: {{value}}` },
      { key: "headerTitleWidget1.7", value: "Data/Period" },
      { key: "headerTitleWidget1.9", value: "Org Units/Period" },
      { key: "jan", value: "January" },
      { key: "feb", value: "Febuary" },
      { key: "mar", value: "March" },
      { key: "apr", value: "April" },
      { key: "may", value: "May" },
      { key: "jun", value: "June" },
      { key: "jul", value: "July" },
      { key: "aug", value: "August" },
      { key: "sep", value: "September" },
      { key: "oct", value: "October" },
      { key: "nov", value: "November" },
      { key: "dec", value: "December" },
      {
        key: "widget1.12Title",
        value: "Reporting Rate - {{year}}",
      },
      {
        key: "widget1.11.1Title",
        value: "Infant Death by Province - {{year}}",
      },
      {
        key: "widget1.11.2Title",
        value: "Child Death by Province - {{year}}",
      },
      {
        key: "widget1.11.3Title",
        value: "Maternal Death by Province - {{year}}",
      },
      {
        key: "widget1.10.1Title",
        value: "Infant mortality rate (Annualised) by Province - {{year}}",
      },
      {
        key: "widget1.10.2Title",
        value: "Child mortality rate (Annualised) by Province - {{year}}",
      },
      {
        key: "widget1.10.3Title",
        value: "Maternal mortality rate (Annualised) by Province - {{year}}",
      },
      {
        key: "widget1.7.1Title",
        value: "Infant Death - Last 3 Years",
      },
      {
        key: "widget1.7.2Title",
        value: "Child Death - Last 3 Years",
      },
      {
        key: "widget1.7.3Title",
        value: "Maternal Death - Last 3 Years",
      },
      {
        key: "widget1.8.1Title",
        value: "Infant mortality rate (Annualised) - Last 3 Years",
      },
      {
        key: "widget1.8.2Title",
        value: "Child mortality rate (Annualised) - Last 3 Years",
      },
      {
        key: "widget1.8.3Title",
        value: "Maternal mortality rate (Annualised) - Last 3 Years",
      },
      {
        key: "widget2.1Title",
        value: "SBA Total - {{year}}",
      },
      {
        key: "widget2.2Title",
        value: "Estimated live births - {{year}}",
      },
      { key: "widget2.3Title", value: "SBA Coverage (Annualized) - {{year}}" },
      {
        key: "widget2.4.1Title",
        value: "SBA Total - Last 3 years",
      },
      {
        key: "widget2.4.2Title",
        value: "SBA coverage (Annualized) - Last 3 years",
      },
      {
        key: "widget2.5.1Title",
        value: "SBA Total by Province - {{year}}",
      },
      {
        key: "widget2.5.2Title",
        value: "SBA coverage (Annualized) by Province - {{year}}",
      },
      {
        key: "widget2.6Title",
        value: "SBA Total by Provinces - {{year}}",
      },
      {
        key: "widget2.7Title",
        value: "SBA Coverage (Annualized) by Province - {{year}}",
      },
      {
        key: "widget2.8Title",
        value: "SBA: Reporting and Timeliness Rate by Province - {{year}}",
      },
      { key: "widget2.9Title", value: "Repoting rate heat map" },
      {
        key: "widget4.1Title",
        value: "% Members registered",
      },
      {
        key: "widget4.2Title",
        value: "% Family without Family book number",
      },
      { key: "widget4.3Title", value: "Total family registered" },
      { key: "widget4.4Title", value: "Total members registered" },
      {
        key: "widget4.5Title",
        value: "% Members registered vs LSB",
      },
      { key: "widget4.6Title", value: "Family source of water" },
      { key: "widget4.7Title", value: "Family sanitation" },
      {
        key: "widget4.8Title",
        value: "Member education",
      },
      {
        key: "widget4.9Title",
        value: "Members by Ethnicity",
      },
      { key: "widget4.10Title", value: "Family with Disability" },
      {
        key: "dashboard4Title",
        value: "Family Health Information System (FHIS)",
      },
      { key: "lastMonth", value: `Last month: {{value}}` },
      {
        key: "dashboard3_widget1.1Title",
        value: `Penta3 Immunization total this month {{year}}`,
      },
      {
        key: "dashboard3_widget2.1Title",
        value: `Penta3 Immunization coverage this month {{year}}`,
      },
      {
        key: "dashboard3_widget3.1Title",
        value: `Penta3 Immunization total {{year}}`,
      },
      {
        key: "dashboard3_widget4.1Title",
        value: `Penta3 Immunization coverage {{year}}`,
      },
      {
        key: "dashboard3_widget5.1Title",
        value: `Monthly Penta3`,
      },
      {
        key: "dashboard3_widget6.1Title",
        value: `Monthly Penta 3 By Province`,
      },
      {
        key: "dashboard3_Widget9.1Title",
        value: `Epi Penta3 Coverage {{year}}`,
      },
      {
        key: "dashboard3_Widget10.1Title",
        value: `Monthly Penta 3 {{year}}`,
      },
      {
        key: "dashboard3_Widget11.1Title",
        value: `EPI DB Reporting and Timeliness Rate Lao PDR {{year}}`,
      },
      {
        key: "dashboard3_Widget12.1Title",
        value: `EPI DB Reporting Rate Heat Map Lao PDR {{year}}`,
      },
      {
        key: "target",
        value: "Target",
      },
      {
        key: "lastUpdated",
        value: "Last updated",
      },
      { key: "asAt", value: "As at" },
      { key: "dashboard5_widget1.1Title", value: "VPD Total - {{year}}" },
      { key: "dashboard5_widget2.1Title", value: "Dengue Total - {{year}}" },
      { key: "dashboard5_widget3.1Title", value: "FWB Total - {{year}}" },
      { key: "dashboard5_widget4.1Title", value: "SARI Total - {{year}}" },
      {
        key: "dashboard5_widget5.1Title",
        value: "Zoonotic Diseases and Others Total - {{year}}",
      },
      { key: "dashboard5_widget6.1Title", value: "VPD Total - {{year}}" },
      {
        key: "dashboard5_widget7.1Title",
        value: "VPD Total by Province - {{year}}",
      },
      { key: "dashboard5_widget8.1Title", value: "Dengue Total - {{year}}" },
      {
        key: "dashboard5_widget9.1Title",
        value: "Dengue Total by Province - {{year}}",
      },
      { key: "dashboard5_widget10.1Title", value: "FWB Total - {{year}}" },
      {
        key: "dashboard5_widget11.1Title",
        value: "FWB Total by Province - {{year}}",
      },
      { key: "dashboard5_widget12.1Title", value: "SARI Total - Last 3 years" },
      {
        key: "dashboard5_widget13.1Title",
        value: "SARI Total by Province - {{year}}",
      },
      {
        key: "dashboard5_widget14.1Title",
        value: "Zoonotic Diseases and Others Total - {{year}}",
      },
      {
        key: "dashboard5_widget15.1Title",
        value: "Zoonotic Diseases and Others - {{year}}",
      },
      {
        key: "dashboard5_widget16.1Title",
        value: "Notifiable Disease Reporting - {{year}}",
      },
      {
        key: "dashboard5_widget17.1Title",
        value: "Notifiable Disease Reporting Rate (annualised) - {{year}}",
      },
      {
        key: "dashboard5Title",
        value: "NCLE - 18 Notifiable Diseases Surveillance",
      },
      {
        key: "dashboard6_widget1Title",
        value: "Life Cycle Chart - Last 12 months",
      },
      {
        key: "dashboard6_widget2Title",
        value: "ANC1 - ANC4 Dropout Rate - Last 12 months",
      },
      {
        key: "dashboard6_widget3Title",
        value: "Penta1 - Penta3 Dropout Rate - Last 12 months",
      },
      {
        key: "dashboard6_widget4Title",
        value: "EPI Reporting and Timeliness Rate by Province - Last 12 months",
      },
      {
        key: "dashboard6Title",
        value: "Mother and Child",
      },
      {
        key: "REPORTING_RATE",
        value: "Reporting rate",
      },
      {
        key: "REPORTING_RATE_ON_TIME",
        value: "Reporting rate on time",
      },
      {
        key: "dataFromDhis2",
        value: "Data reported in DHIS2 only",
      },
      {
        key: "widget2.5.1LegendTitle",
        value: "SBA Total",
      },
      {
        key: "widget2.5.2LegendTitle",
        value: "MCH: SBA coverage (Annualized)",
      },
      {
        key: "dashboard7Title",
        value: "HMIS Super Doc",
      },
      {
        key: "dashboard8Title",
        value: "OrgUnit Profile",
      },
      {
        key: "dashboard8_widget1Title",
        value: "Health Facility Master List Online (Lao PDR)",
      },
      {
        key: "Quarterly Nutrition Scorecard - Key Indicators",
        value: "Quarterly Nutrition Scorecard - Key Indicators",
      },
      {
        key: "Quarterly Nutrition Scorecard - Data Quality",
        value: "Quarterly Nutrition Scorecard - Data Quality",
      },
      { key: "accessToFacility", value: "Access To Facility" },
      { key: "facilityInformation", value: "Facility Information" },
      { key: "facilityInfrastructure", value: "Facility Infrastructure" },
      { key: "serviceDetailsLastYear", value: "Service Details Last Year" },
      { key: "servicesProvided", value: "Services Provided" },
      { key: "staffDetails", value: "Staff Details" },
      { key: "all", value: "All" },
      { key: "provided", value: "Provided" },
      { key: "notProvided", value: "Not provided" },
      { key: "dashboard8_tabWidgetTitle", value: "Select section" },
      { key: "summary", value: "Summary" },
      { key: "departmentsOrOffices", value: "Departments/Offices" },
      { key: "hospitalsByProvince", value: "Hospitals by province" },
      { key: "hospitalsByLevel", value: "Hospitals by level" },
      { key: "allHospitals", value: "All hospitals" },
      { key: "province", value: "Province " },
      { key: "district", value: "District" },
      { key: "healthCenter", value: "Health Center" },
      { key: "capitalOrProvince", value: "Capital / Province" },
      { key: "hospitalTotal", value: "Hospital Total" },
      { key: "capitalOrProvinceHospital", value: "C/PHO" },
      { key: "provinceHospital", value: "PH" },
      { key: "districtHospital", value: "DHO" },
      { key: "districtHospitalCommunity", value: "DH (Community)" },
      { key: "districtHospitalCommunityTotal", value: "DH Total" },
      { key: "districtHospitalCommunityA", value: "(DH-A)" },
      { key: "districtHospitalCommunityB", value: "(DH-B)" },
      { key: "healthCenterWithCode", value: "HC (Health Center)" },
      { key: "code", value: "Code" },
      { key: "total", value: "Total" },
      { key: "centralHospital", value: "Central Hospital (CH)" },
      { key: "tag", value: "Tag" },
      { key: "hfid", value: "HFID" },
      { key: "type", value: "Type" },
      { key: "shortName", value: "Short name" },
      { key: "name", value: "Name" },
      { key: "yes", value: "Yes" },
      { key: "no", value: "No" },
      {
        key: "homeTitle",
        value: "Welcome to Lao PDR's National Health Public Dashboards",
      },
      {
        key: "homeSubTitle",
        value:
          "The National Health Dashboards provide a comprehensive overview of public health in Lao PDR.",
      },
      {
        key: "homeDashboardTitle",
        value: "Home",
      },
      { key: "pleaseSelectDashboard", value: "Please select dashboard" },
      {
        key: "disclaimer",
        value: "*Disclaimer*",
      },
      {
        key: "disclaimerSubTitle",
        value:
          "The information and data provided in these dashboards are for informational purposes only and should not be used as an official reference.",
      },
      {
        key: "aboutSectionTitle",
        value: "About National Public Health Dashboard of Lao PDR",
      },
      {
        key: "aboutSectionLine1",
        value:
          "The Public Health Dashboard of Lao PDR is a web-based platform that provides up-to-date data and insights on the public health of the country, developed by the Department of Planning and Finance, Ministry of Health of Lao PDR.",
      },
      {
        key: "aboutSectionLine2",
        value:
          "This dashboard is a valuable tool for monitoring the public health situation in Lao PDR, identifying trends, and developing interventions to improve the health of the population.",
      },
      {
        key: "howToUseTitle",
        value: "How to use the dashboard",
      },
      {
        key: "howToUseLine1",
        value:
          "From the home page you can select the dashboard you want to view from the dropdown in the middle or on the top left of the page.",
      },
      {
        key: "howToUseLine2",
        value:
          "The dashboard also provides interactive features that allow you to explore the data in more detail. For example, you can click on the “ …” button to switch between charts:",
      },
      {
        key: "whoIsDashboardForTitle",
        value: "Who is the dashboard for?",
      },
      {
        key: "whoIsDashboardForLine1",
        value:
          "The National Public Health Dashboard of Lao PDR is for public health workers/officials  or researchers to:",
      },
      {
        key: "whoIsDashboardForLine2",
        value: "Monitor the public health situation in Lao PDR",
      },
      {
        key: "whoIsDashboardForLine3",
        value: "Identify trends in public health data",
      },
      {
        key: "whoIsDashboardForLine4",
        value: "Develop interventions to improve the health of the population",
      },
      {
        key: "howDashboardMadeTitle",
        value: "How is the dashboard made?",
      },
      {
        key: "howDashboardMadeLine1",
        value:
          "The National Public Health Dashboard of Lao PDR is developed by the Department of Planning and Finance, Ministry of Health of Lao PDR in collaboration with HISP Vietnam.",
      },
      { key: "control", value: "Control" },
      { key: "columns", value: "Columns" },
      { key: "filter", value: "Filter" },
      { key: "sort", value: "Sort" },
      { key: "filterBy", value: "Filter by {{label}}" },
      { key: "reset", value: "Reset" },
      { key: "emptyData", value: "Data is empty" },
      { key: "sortStatus", value: "Sort status" },
      { key: "asc", value: "Ascending (ASC)" },
      { key: "desc", value: "Descending (DESC)" },
      { key: "location", value: "Location" },
      { key: "facilityName", value: "Facility Name" },
      { key: "downloadExcel", value: "Download excel" },
      { key: "availableColumns", value: "Available columns" },
      { key: "selectedColumns", value: "Selected columns" },
      { key: "dashboard8_widget1_title", value: "Master Facilities List" },
      { key: "config", value: "Config" },
      {
        key: "profile",
        value: "Profile",
      },
      {
        key: "dataElement",
        value: "Data element",
      },
      {
        key: "dataValue",
        value: "Data value",
      },
      {
        key: "close",
        value: "Close",
      },
      {
        key: "trackedEntityAttribute",
        value: "Tracked entity instance",
      },
      {
        key: "detail",
        value: "Detail",
      },
      {
        key: "photoNotAvailable",
        value: "Photo not available",
      },
    ],
  },
];

export default locales;
